import {Sprite} from 'pixi.js';

export interface BackgroundData {
    id: string;
    view: Sprite;
}

export class BackgroundConstants {
    public static readonly TRANSFER_TIME: number = 500;
    public static readonly SPINE_NAME: string = 'background';

    public static readonly BASE_VIEW: string = 'base';
    public static readonly FREE_SPINS_VIEW: string = 'freespins';
    public static readonly backgroundViewName = Symbol('BackgroundView');
}
